// A client may have several CS owners, one input each, and one reminder goes to all of them.
// Kept out of ClientForm so the rules can be tested without mounting the form, and so they stay
// visibly the counterpart of CsOwnerRecipients on the backend, which re-checks every address and
// stores one row per address.

// Kept in step with CsOwnerRecipients::MAX_RECIPIENTS on the backend.
export const MAX_CS_OWNER_EMAILS = 10;

// Same acceptance as /^[^\s@]+@[^\s@]+\.[^\s@]+$/: no whitespace, exactly one "@" with something
// before it, and a "." in the domain with something on both sides of it.
export const isValidEmail = (value) => {
  const text = String(value);
  const at = text.indexOf("@");
  if (at < 1 || at !== text.lastIndexOf("@") || /\s/.test(text)) {
    return false;
  }

  return text.slice(at + 1).slice(1, -1).includes(".");
};

const key = (address) => address.trim().toLowerCase();

// Blank rows are dropped rather than failed: an input added with + and left empty is normal, and
// the backend drops them too. Repeats keep their first spelling, as the backend does.
export const normalizeEmails = (list) => {
  const seen = new Set();

  return list
    .map((address) => address.trim())
    .filter((address) => {
      if (address === "" || seen.has(key(address))) {
        return false;
      }
      seen.add(key(address));
      return true;
    });
};

export const areValidEmails = (list) => {
  const addresses = normalizeEmails(list);

  return (
    addresses.length > 0 &&
    addresses.length <= MAX_CS_OWNER_EMAILS &&
    addresses.every(isValidEmail)
  );
};

// Rows repeating an earlier row. They would be dropped silently on save, so the form flags them
// instead, which leaves the user in no doubt about what gets stored.
export const duplicateIndexes = (list) => {
  const seen = new Set();
  const duplicates = new Set();

  list.forEach((address, index) => {
    if (address.trim() === "") {
      return;
    }
    if (seen.has(key(address))) {
      duplicates.add(index);
    }
    seen.add(key(address));
  });

  return duplicates;
};
